import type { AssetUploadGateway } from '#/domain/assetsLink/AssetUploadGateway'

export class UploadAssetUseCase {
  constructor(private readonly gateway: AssetUploadGateway) {}

  async execute(sasUri: string, file: File, folder: string): Promise<void> {
    return this.gateway.upload(sasUri, file, folder)
  }
}
